/*eslint-disable */
import { useCallback, useEffect, useState } from 'react';
import { Filter } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import GlobalSearch from '@/Components/globalSearch/search';
import { filtersInfoChip, getUnitConvertedQuantity, getUnitConvertedUnit } from '@/Helpers';
import VariantTable from '@/Pages/Food Products/VariantPrice/VariantTable';
import Tab from '@/Components/InfoTab/tab';
import { Button } from '@/Components/ui/button';
import drawerActions from '@/Actions/drawer.actions';
import ImagesFinder from '@/Components/ImagesFinder/ImagesFinder';
import inventoryAnalyticsServices from '@/Services/Analytics Services/inventory-analytics.services';
import moment from 'moment';
import { useProductData } from '@/Helpers';
import StockHistoryDrawer from '@/Components/Drawers/StockHistoryDrawer/StockHistoryDrawer';


export const Tabs = [
	{
		id: 0,
		title: 'ALL',
		displayName: 'ALL',
	},
	{
		id: 1,
		title: 'Section 1',
		displayName: 'Section 1',
	},
	{
		id: 2,
		title: 'Section 2',
		displayName: 'Section 2',
	},
	{
		id: 3,
		title: 'Section 3',
		displayName: 'Section 3',
	},
];

const columns = [
    {
        title: 'Item Id',
        key: 'variantId',
    },
    {
        title: 'Item Name',
        key: 'variantName',
    },
    // {
    //     title: 'Avg Holding time',
    //     key: 'holding time',
    // },
    {
        title: 'Consumption Qty[In Tons]',
        key: 'skuType',
		sortable: true,
    },
    {
        title: 'Item Price',
        key: 'openingStock',
        sortable: true,
    },
    {
        title: 'Consumption Cost[In Lacs]',
        key: 'totalStockIn',
        sortable: true,
    },
    {
        title: '% Total',
        key: 'totalStockOut',
        sortable: true,
    },
    // {
    //     title: 'Closing Stock',
    //     key: 'closingStock',
    //     sortable: true,
    // },
    // {
    //     title: 'Wastage',
    //     key: 'wastage',
    // },
    // {
    //     title: 'Variance',
    //     key: 'variance',
    // },
    // {
    //     title: 'Expiring',
    //     key: 'expired',
    // },
    // {
    //     title: 'Total Shrinkage',
    //     key: 'totalShrinkage',
    // },
];

const colMap = {
    // 'variantId': 'variantId',
    // 'Total Stocked In': 'totalStockIn',
    // 'Total Stocked Out': 'totalStockOut',
    // 'Opening Stock': 'openingStock',
    // 'Closing Stock': 'closingStock',
    // Wastage: 'wastage',
    // Variance: 'variance',
    // Expiring: 'expired',
};

function ABCAnalysis() {
    const [selectTab, setSelectTab] = useState(0);
    const [search, setSearch] = useState(null);
    const [data, setData] = useState([]);
    const [filterValue, setFilterValue] = useState({});
    const products = useSelector((state) => state?.form?.ALL_PRODUCTS?.data?.LIST);
    const dispatch = useDispatch();
    const emptyVariant = products?.every((product) => product?.variants?.length === 0);

    useEffect(() => {
        if (emptyVariant) {
            // useProductData(dispatch);
        }
    }, [emptyVariant]);

    const dropDownItems = [
        {
            label: 'Item Id',
            value: 'variantId',
            placeholder: 'Search by Item Id',
        },
        {
            label: 'Item Name',
            value: 'variantName',
            placeholder: 'Search by Item Name',
        },
    ];

    const filtersInfo = {
		header: {
			store : false,
			date: false,
		},
        store: {
            text: 'Select Store',
            show: true,
            noAllOption: true
        },
        dateRangeOnly: {
            text: 'Select Date Range',
            show: true,
            noAllOption: true
        },
    }

    const fetchData = async (filters) => {
        setFilterValue(filters);
        // try {
        //     const response = await inventoryAnalyticsServices.dayWiseSkuTrail({
        //         data: {
        //             storeId: filters?.store?.id,
        //             dateRangeFilter: {
        //                 from: moment(filters?.dateOnly?.date).format(
        //                     'YYYY-MM-DD'
        //                 ),
        //                 to: moment(filters?.dateOnly?.date).format('YYYY-MM-DD'),
        //             },
        //         },
        //     });
        //     if (response?.responseCode === 'SS-001') {
        //         const data = response?.data;
        //         const newData = data.map((item) => {
        //             return {
        //                 ...item,
        //                 variantName: getVariantName(item),
        //             }
        //         });
        //         setData(newData);
        //     }
        // } catch (error) {
        //     // eslint-disable-next-line no-console
        //     console.log('error', error);
        // }
    };

    // const handleTrailDrawer = (obj) => {
    //     dispatch(drawerActions.toggleStockHistoryDrawer(true, {
    //         type: undefined,
    //         selectedStore: { id: filterValue?.store?.id, title: filterValue?.store?.name },
    //         itemDetails: {
    //             ...obj,
    //             skuType: obj?.product?.skuType,
    //             unit: obj?.product?.unit,
    //             variantId: obj?.variantId,
    //             variantName: obj?.variantName,
    //         },
    //         heading: `Stock Trail of ${obj?.product?.productName
    //             }${obj?.variantName
    //                 ? `(${obj?.variantName})`
    //                 : ''
    //             }`,
    //     }));
    // }
    const customRowData = {
        // 'holdingtime': (obj, index) => {
        //     return "";
        // },
        // 'totalShrinkage': (obj, index) => {
        //     const unit = obj?.product?.unit ?? '';
        //     const wastage = parseFloat(getUnitConvertedQuantity(obj?.wastage, unit, true, true, true)) || 0;
        //     const variance = parseFloat(getUnitConvertedQuantity(obj?.variance, unit, true, true, true)) || 0;
        //     const expired = parseFloat(getUnitConvertedQuantity(obj?.expired, unit, true, true, true)) || 0;
        //     const value = wastage + variance + expired;
        //     return <div className='text-[12px]'>{value}</div>;
        // },
        // 'variantName': (obj, index) => {
        //     return <div className='text-[12px]'>{obj?.variantName ?? ''}</div>;
        // },
        // 'skuType': (obj, index) => {
        //     const skuType = obj?.product?.skuType ?? '';
        //     return <div className='text-[12px]'> {skuType} </div>;
        // },
        // 'openingStock': (obj, index) => {
        //     const unit = obj?.product?.unit ?? '';
        //     return <div className='text-[12px]'>{getUnitConvertedQuantity(obj?.openingStock, unit, true, true, true)} {getUnitConvertedUnit(1, unit, true)}</div>;
        // },
        // 'totalStockIn': (obj, index) => {
        //     const unit = obj?.product?.unit ?? '';
        //     return <div className='text-[12px]'>{getUnitConvertedQuantity(obj?.totalStockIn, unit, true, true, true)} {getUnitConvertedUnit(1, unit, true)}</div>;
        // },
        // 'totalStockOut': (obj, index) => {
        //     const unit = obj?.product?.unit ?? '';
        //     return <div className='text-[12px]'>{getUnitConvertedQuantity(obj?.totalStockOut, unit, true, true, true)} {getUnitConvertedUnit(1, unit, true)}</div>;
        // },
        // 'closingStock': (obj, index) => {
        //     const unit = obj?.product?.unit ?? '';
        //     return <div className='flex gap-2 justify-between items-center'>
        //         <span className='text-[12px] text-nowrap'>{getUnitConvertedQuantity(obj?.closingStock, unit, true, true, true)} {getUnitConvertedUnit(1, unit, true)}</span>
        //         <span className='text-[14px] text-yellow-400 hover:text-yellow-500 cursor-pointer' onClick={() => handleTrailDrawer(obj)}>Trail</span>
        //     </div>;
        // },
        // wastage: (obj, index) => {
        //     const unit = obj?.product?.unit ?? '';
        //     return <div className='text-[12px]'>{getUnitConvertedQuantity(obj?.wastage, unit, true, true, true)} {getUnitConvertedUnit(1, unit, true)}</div>;
        // },
        // variance: (obj, index) => {
        //     const unit = obj?.product?.unit ?? '';
        //     return <div className='text-[12px]'>{getUnitConvertedQuantity(obj?.variance, unit, true, true, true)} {getUnitConvertedUnit(1, unit, true)}</div>;
        // },
        // expired: (obj, index) => {
        //     const unit = obj?.product?.unit ?? '';
        //     return <div className='text-[12px]'>{getUnitConvertedQuantity(obj?.expired, unit, true, true, true)} {getUnitConvertedUnit(1, unit, true)}</div>;
        // },
    }

    const sortValueInfo = {
        // 'openingStock': {
        //     type: 'number',
        //     path: 'obj?.openingStock',
        //     customValue: true,
        //     value: (obj) => {
        //         return getUnitConvertedQuantity(obj?.openingStock, obj?.product?.unit, true, true, true);
        //     },
        // },
        // 'totalStockIn': {
        //     type: 'number',
        //     path: 'obj?.totalStockIn',
        //     customValue: true,
        //     value: (obj) => {
        //         return getUnitConvertedQuantity(obj?.totalStockIn, obj?.product?.unit, true, true, true);
        //     },
        // },
        // 'totalStockOut': {
        //     value: 'totalStockOut',
        //     type: 'number',
        //     path: 'obj?.totalStockOut',
        //     customValue: true,
        //     value: (obj) => {
        //         return getUnitConvertedQuantity(obj?.totalStockOut, obj?.product?.unit, true, true, true);
        //     },
        // },
        // 'closingStock': {
        //     type: 'number',
        //     path: 'obj?.closingStock',
        //     customValue: true,
        //     value: (obj) => {
        //         return getUnitConvertedQuantity(obj?.closingStock, obj?.product?.unit, true, true, true);
        //     },
        // },
    }

    const generatedData = useCallback(() => {
    }, []);

    const handleTabChange = (value) => {
        setSelectTab((prev) => {
            if (prev === value) {
                return null;
            }
            return value;
        });
    }
    const exportInfo = {
        showDropDown: false,
		showExportBtn: false,
	};
    return (
        <div className='flex flex-col p-2'>
            <StockHistoryDrawer />
            <ImagesFinder
                onSubmit={fetchData}
                filtersInfo={filtersInfo}
                disableFutureDate={true}
                exportInfo={exportInfo}
            />

            <div className='flex items-center justify-between mb-4 w-full'>
                <h1 className='text-xl font-bold'>ABC Analysis</h1>
            </div>
            <div className='flex items-center justify-start gap-3 mb-4 w-full'>
                <div className='w-[50%]'>
                    <GlobalSearch
                        dropDownOptions={dropDownItems}
                        searchDropDown
                        setSelectedValue={setSearch}
                    />
                </div>
                <Tab
                    tabList={Tabs.map((item) => ({
                        label: item.title,
                        value: item.id,
                    }))}
                    tabValue={selectTab}
                    handleTabChange={(value) => handleTabChange(value)}
                    activeTabColor='bg-yellow-200'
                />
                <Button
                    onClick={() => {
                        dispatch(drawerActions.toggleFiltersDrawer(true));
                    }}
                    className='flex items-center gap-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
                >
                    <span className='text-nowrap'>Filter & Export</span>
                    <Filter className='size-4' />
                </Button>
            </div>
            {filtersInfoChip(filtersInfo, filterValue)}
            <div className='flex-1 max-h-[calc(100vh-240px)] overflow-y-auto'>
                <VariantTable
                    data={generatedData()}
                    columns={columns}
                    colMapping={colMap}
                    customRowData={customRowData}
                    sortValueInfo={sortValueInfo}
                />
            </div>
        </div>
    );
}
export default ABCAnalysis;
